import { LTAtomsActions } from '@/components/design-system/atoms/actions'
import { TLAtomsIcons } from '@/components/design-system/atoms/icons'
import { TLAtomsInformation } from '@/components/design-system/atoms/information'

export const TLAtoms = {
  Icons: TLAtomsIcons,
  ...LTAtomsActions,
  ...TLAtomsInformation
}
